<template style="z-index: 100;">
  <v-layout column>
    <v-flex>
      <app-google-translator/>
    </v-flex>
    <v-flex class="text-xs-right confirmationPrintContainer">
      <span @click="print" class="hover">
        <v-icon left class="black--text notranslate">print</v-icon>
        <span>Print</span>
      </span>
    </v-flex>
    <v-flex>
      <div class="appConfirmationTitle">
        Thank You. Your Order Has Been Submitted.
      </div>
      <div class="appConfirmationNumber">
        Your Confirmation Number is:<br/>
        {{openEndedOrderData.id}}
      </div>
    </v-flex>
    <v-flex>
      <div class="appConfirmationDescription mb-5">
        Thank you {{ firstName }}! Once your order is processed,
        we will send you a confirmation within the next 24 hours
        to {{ emailAddress }} with your coverage information and other details. Please contact us
        with any questions. We are here to help.
        <br/>
        <br/>
        Phone: 844-849-4827 (M-F 8am – 5pm PST)
        <br/>
        <span>Help Center: <a class="confirmationHelpText" :href="helpLink"
                              target="_blank">24/7 Support</a></span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import AppGoogleTranslator from 'components/AppGoogleTranslator.vue';
import urlUtils from 'utils/url';

export default {
  name: 'Confirmation',
  components: {
    AppGoogleTranslator,
  },
  data: () => ({
    firstName: '',
    emailAddress: '',
    underwriter: '',
  }),
  mounted() {
    if (this.customerInfo && this.customerInfo.first_name) {
      this.firstName = this.customerInfo.first_name;
      this.emailAddress = this.customerInfo.email;
    } else if (this.userInformation) {
      this.firstName = this.userInformation.firstName.charAt(0)
        .toUpperCase()
        + this.userInformation.firstName.slice(1);
      this.emailAddress = this.userInformation.email;
    } else if (this.payloadCustomer) {
      this.firstName = this.payloadCustomer.first_name;
      this.emailAddress = this.payloadCustomer.email;
    }

    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage({});
    }
  },
  methods: {
    print() {
      window.print();
    },
  },
  computed: {
    ...mapGetters(['urlParams']),
    ...mapGetters('widgetData', ['widgetData']),
    ...mapGetters('order', ['orderInfo', 'addressCustomer', 'customerInfo', 'openEndedOrderData']),
    ...mapGetters('quote', ['payloadCustomer', 'userInformation', 'openEndedTokenUrl']),
    helpLink() {
      const productFromUrl = urlUtils.getProductFromDomain();
      return productFromUrl !== 'enhancedrefundprogram' ? 'https://help.fanshield.com/s/topic/0TO6g000000suYtGAI/refund-program-faq' : 'https://protecht.com/enhanced-refund-program-faq/';
    },
  },
};
</script>

<style scoped>
.appConfirmationTitle {
  font-family: Gotham;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}

.appConfirmationNumber {
  font-family: Gotham;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0 auto;
  padding-top: 0px;
  padding-bottom: 30px;
}

.appConfirmationNewEvent {
  font-family: Gotham;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}

.appConfirmationDescription {
  width: 1050px;
  height: 175px;
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
  margin: 0 auto;
}

.confirmationPrintContainer {
  padding: 15px 15px 0 0;
}

.confirmationHelpText {
  text-decoration: none;
}

/* Extra large Break Point */
@media screen and (min-width: 1904px) {
  .appConfirmationDescription {
    width: 1163px;
    height: 136px;
  }
}

/* Extra large Break Point */
@media screen and (min-width: 1265px) and (max-width: 1904px) {
  .confirmationButtonContainer {
    padding-left: 10px;
  }
}

/* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .appConfirmationDescription {
    width: 688px;
    height: 190px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appConfirmationDescription {
    width: 280px;
    height: 340px;
  }

  .confirmationButton {
    width: 240px;
  }
}
</style>
